/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

class Template extends React.Component {
	render() {
		let productsArr = [
			'The Etho Flowers in December Print Blouse',
			'CeCe Wildflower Fling Top',
			'The Etho Flowers in Her HAir Smock',
			'CeCe Floral Print Puff Sleeve Top',
			'Topshop Floral Pintuck Shirt',
			'Topshop Floral Knot Front Shirt',
			'Foxcroft Ava Ditsy Floral Print Shirt',
			'Rip Curl Island Time Tie Strap Tank'
		]

		return (
			<div className='main-container'>
				<Section className='height-auto'>
					<div className='container'>
						<div className='row'>
							<div className='col-sm-8 col-md-7'>
								<h2>Saloni</h2>
							</div>
						</div>
					</div>
				</Section>

				<Section id='brand__section'>
					<div className='col-md-3'>
						<h4>Shop This Brand</h4>
						<ul className='brand-category-list'>
							<li>
								<a href='/brand-directory/brand/shop'>
									Shop All
								</a>
							</li>
							<li>
								<a href='/brand-directory/brand/shop'>
									Dresses
								</a>
							</li>
							<li>
								<a href='/brand-directory/brand/shop'>Tops</a>
							</li>
							<li>
								<a href='/brand-directory/brand/shop'>
									Accessories
								</a>
							</li>
							<li>
								<a href='/brand-directory/brand/shop'>
									Women's Yoga
								</a>
							</li>
						</ul>
					</div>
					<div className='col-md-9'>
						<div className='row'>
							<div className='brand__header col-12 bg--secondary'>
								<h3>Saloni</h3>
								<ul className='brand-category-list'>
									<li>
										<a href='/brand-directory/brand/shop'>
											Dresses
										</a>
									</li>
									<li>
										<a href='/brand-directory/brand/shop'>
											Tops
										</a>
									</li>
									<li>
										<a href='/brand-directory/brand/shop'>
											Accessories
										</a>
									</li>
									<li>
										<a href='/brand-directory/brand/shop'>
											Women's Yoga
										</a>
									</li>
								</ul>
								<p>
									Lorem ipsum dolor sit amet consectetur
									adipisicing elit. Architecto similique illum
									soluta sunt rerum ratione, praesentium unde
									eaque dolore provident. Laudantium quaerat
									nihil neque culpa distinctio eos placeat
									ipsa debitis voluptate pariatur libero eaque
									vel facilis eum nesciunt fuga deserunt ut
									sunt ratione, quasi saepe porro ullam a id.
									Tempore!
								</p>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<span className='bold'>Filter:</span>
								<span>
									<DropdownButton
										id='sizes__dropdown'
										title='Sizes'>
										<Dropdown.Item>xs</Dropdown.Item>
										<Dropdown.Item>sm</Dropdown.Item>
										<Dropdown.Item>md</Dropdown.Item>
										<Dropdown.Item>lg</Dropdown.Item>
										<Dropdown.Item>xl</Dropdown.Item>
									</DropdownButton>
								</span>
								<span>
									<DropdownButton
										id='colors__dropdown'
										title='Colors'>
										<Dropdown.Item>Maroon</Dropdown.Item>
										<Dropdown.Item>Pink</Dropdown.Item>
										<Dropdown.Item>Yellow</Dropdown.Item>
									</DropdownButton>
								</span>
							</div>
							<div className='col-md-6 text-right'>
								<span className='bold'>Sort By:</span>
								<DropdownButton
									id='sort__dropdown'
									title='Sort'>
									<Dropdown.Item>Newest</Dropdown.Item>
									<Dropdown.Item>
										Price: Low -> High
									</Dropdown.Item>
									<Dropdown.Item>
										Price: High -> Low
									</Dropdown.Item>
									<Dropdown.Item>
										My{' '}
										<FAI
											icon='heart'
											color='rgba(254, 240, 233, 1)'
										/>
									</Dropdown.Item>
								</DropdownButton>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<span>51 items</span>&emsp;|
								<span>Items/Page:</span>
								<span>40</span>
								<span>100</span>
							</div>
							<div className='col-md-6'>
								<div className='pagination__container'>
									<ul>
										<li>1</li>
										<li>2</li>
										<li>3</li>
									</ul>
								</div>
							</div>
						</div>
						<hr />
						<div className='row'>
							{productsArr.map((product, i) => {
								return (
									<div className='col-md-4' key={i}>
										<a
											href='/category/subcategory/product'
											className='card'>
											<div className='card-img-top'>
												<img
													src='https://placehold.it/240x360'
													alt='placeholder'
												/>
											</div>
											<div className='card-body'>
												<h4 className='card-title'>
													{product}
												</h4>
												<span className='semi-bold'>
													$49.99
												</span>
												<span className='text-muted'>
													New!
												</span>
												<p className='card-text'>
													Lorem ipsum dolor sit amet
													consectetur adipisicing
													elit. Temporibus, eaque.
												</p>
											</div>
										</a>
									</div>
								)
							})}
						</div>
					</div>
				</Section>
			</div>
		)
	}
}

export default Template
